import React from "react";
import { Snackbar, Text } from "react-native-paper";
import { MainContext } from "../../contexts/MainContext";

export default function CustomSnackbar({title = false, leftText = false}) {
  const myContext = React.useContext(MainContext);

  return (
    <Snackbar
      style={{ width: '95%', backgroundColor: '#444', marginRight: 'auto', marginLeft: 'auto', marginBottom: 65 }}
      visible={myContext.snackbar.active}
      duration={3000}
      onDismiss={() => {
        myContext.activateSnackbar(false, null)
      }}
    >
      <Text style={{fontSize: 14, color: '#fff'}}>{myContext.snackbar.message}</Text>
    </Snackbar>
  );
}
